import styled, { css } from 'styled-components'
import { tokens } from 'styling/tokens'

export const WorkflowLogicContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 500px;
  position: relative;
  ${(props) => props.theme.container};
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .react-flow {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  .react-flow__background {
    background: ${tokens.surface.raised};
  }

  .react-flow__attribution {
    display: none;
  }

  .react-flow__edge-path {
    stroke: ${tokens.accent.base};
    stroke-width: 2;
  }

  .react-flow__edge.selected .react-flow__edge-path {
    stroke: ${tokens.accent.base};
    stroke-width: 3;
  }

  .react-flow__handle {
    width: 10px;
    height: 10px;
    background: ${tokens.accent.base};
    border: 2px solid ${tokens.surface.raised};
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .react-flow__handle-left {
    left: 0;
  }

  .react-flow__handle-right {
    left: auto;
    right: 0;
    transform: translate(50%, -50%);
  }

  .react-flow__controls {
    box-shadow: ${tokens.shadow.card};
    border-radius: ${tokens.radius.control};
    overflow: hidden;
  }

  .react-flow__controls-button {
    background: ${tokens.surface.raised};
    border-bottom: 1px solid ${tokens.border.hairline};

    svg {
      fill: ${tokens.text.primary};
    }
  }

  .react-flow__controls-button:hover {
    background: ${tokens.border.strong};
  }
`

export const WorkflowLogicToolbar = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 5;
  display: flex;
  align-items: center;
`

export const WorkflowDropEmptyHint = styled.div<{ visible: boolean }>`
  position: absolute;
  inset: 0;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${tokens.text.primary};
  opacity: 0.55;
  font-size: 0.875rem;
  z-index: 1;
`

export const EdgeDeleteButton = styled.button<{ show?: boolean }>`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${tokens.surface.raised};
  color: ${tokens.text.primary};
  border: 1.5px solid ${tokens.accent.base};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  box-shadow: ${tokens.shadow.card};
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${tokens.accent.base};
    color: ${tokens.accent.ink};
  }
`

export const TaskNodeContainer = styled.div<{ root?: boolean; selected?: boolean }>`
  width: 180px;
  min-height: 70px;
  padding: 0.75rem 1rem;
  background: ${tokens.surface.raised};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.root &&
    css`
      border-color: ${tokens.accent.base};
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: ${tokens.accent.glow};
      border-color: ${tokens.accent.base};
    `}

  &:hover {
    box-shadow: ${tokens.shadow.card};
  }
`

export const TaskNodeTitle = styled.div`
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
  word-break: break-word;
  pointer-events: none;
`

export const TaskNodeDelete = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;

  svg {
    width: 12px;
    height: 12px;
  }

  ${TaskNodeContainer}:hover & {
    opacity: 1;
  }

  &:hover {
    background: ${tokens.status.danger.bg};
  }
`
